import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { contentfulModels, components } from '@glowforge/ui-common';

import { pagePropType } from 'app/common/selectors/page';


import './order-footer.less';

const { getSectionForPageByIdAndType } = contentfulModels;
const { SVG } = components;

const OrderFooter = (props) => {
  const iconList = getSectionForPageByIdAndType(props.pageInfo, 'order-page-footer-payment-logos', 'list');
  const icons = _.map(iconList.listItems, (icon, index) => {
    const asset = _.get(icon, 'fields.svgAsset');
    return asset ? <SVG key={index} core={false} svgAsset={asset} /> : null;
  });

  return (
    <div className='OrderFooter'>
      <div className='iconList'>
        {icons}
      </div>
    </div>
  );
};

OrderFooter.propTypes = {
  pageInfo: PropTypes.shape(pagePropType).isRequired,
};

export default OrderFooter;



// WEBPACK FOOTER //
// ./app/store/components/glowforge/order-footer.jsx